<template>
  <div
    :class="[
      'fcom_calendar_event',
      {
        'is-multi-day': isMultiDay,
        'is-continued': isContinued,
        'is-start': isStart,
        'is-end': isEnd,
        'is-week-view': weekView,
      },
    ]"
    :style="eventStyle"
    role="button"
    :aria-label="event.title"
    @mouseenter="onMouseEnter"
    @mouseleave="$emit('leave')"
    @click="$emit('click', event)"
  >
    <span class="fcom_calendar_event-title">{{ event.title }}</span>
    <span v-if="showTime && event.time_display && !weekView" class="fcom_calendar_event-time">
      {{ event.time_display }}
    </span>
    <span v-if="weekView && event.time_display" class="fcom_calendar_event-time-sub">
      {{ event.time_display }}
    </span>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  event:       { type: Object,  required: true },
  showTime:    { type: Boolean, default: true },
  isMultiDay:  { type: Boolean, default: false },
  isContinued: { type: Boolean, default: false },
  isStart:     { type: Boolean, default: true },
  isEnd:       { type: Boolean, default: true },
  weekView:    { type: Boolean, default: false },
})

const emit = defineEmits(['click', 'hover', 'leave'])

const categoryColor = computed(() => {
  if (props.event.category?.color) return props.event.category.color
  if (props.event.categories?.[0]?.color) return props.event.categories[0].color
  return 'var(--fcom-primary-button)'
})

const textColor = computed(() => {
  const c = categoryColor.value
  if (!c.startsWith('#')) return undefined
  const r = parseInt(c.slice(1, 3), 16)
  const g = parseInt(c.slice(3, 5), 16)
  const b = parseInt(c.slice(5, 7), 16)
  return (r * 299 + g * 587 + b * 114) / 1000 > 128 ? '#000000' : '#ffffff'
})

const eventStyle = computed(() => ({
  backgroundColor: categoryColor.value,
  ...(textColor.value ? { color: textColor.value } : {}),
}))

function onMouseEnter(e) {
  emit('hover', { event: props.event, rect: e.target.getBoundingClientRect() })
}
</script>
